module.exports = __webpack_public_path__ + "static/media/award.e9ede4e2.svg";